// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class NoteTaskCreateModel {
    static getAttributeTypeMap() {
        return NoteTaskCreateModel.attributeTypeMap;
    }
}
NoteTaskCreateModel.discriminator = undefined;
NoteTaskCreateModel.additionalProperties = false;
NoteTaskCreateModel.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "caseId",
        "baseName": "caseId",
        "type": "number"
    },
    {
        "name": "assignedUserId",
        "baseName": "assignedUserId",
        "type": "number"
    },
    {
        "name": "dueDate",
        "baseName": "dueDate",
        "type": "Date"
    },
    {
        "name": "isCompleted",
        "baseName": "isCompleted",
        "type": "boolean"
    },
    {
        "name": "completionDate",
        "baseName": "completionDate",
        "type": "Date"
    },
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
    {
        "name": "resolution",
        "baseName": "resolution",
        "type": "string"
    },
    {
        "name": "typeId",
        "baseName": "typeId",
        "type": "number"
    },
    {
        "name": "subject",
        "baseName": "subject",
        "type": "string"
    },
    {
        "name": "body",
        "baseName": "body",
        "type": "string"
    },
];
//# sourceMappingURL=noteTaskCreateModel.js.map